/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
function loadIntercom({ hideOnMobile } = { hideOnMobile: false }) {
  console.log(hideOnMobile);
  // const t = window;
  // const e = t.Intercom;
  // if (typeof e == "function") e("reattach_activator"), e("update", t.intercomSettings);
  // else {
  //   const n = document;
  //   const o = function () {
  //     o.c(arguments);
  //   };
  //   (o.q = []),
  //     (o.c = function (t) {
  //       o.q.push(t);
  //     }),
  //     (t.Intercom = o);
  //   const i = function () {
  //     const e = n.createElement("script");
  //     (e.type = "text/javascript"),
  //       (e.async = !0),
  //       (e.src = "https://widget.intercom.io/widget/lw5f27r8");
  //     const o = n.getElementsByTagName("script")[0];
  //     o.parentNode.insertBefore(e, o),
  //       (e.onload = function () {
  //         t.Intercom("show");
  //         if (hideOnMobile) {
  //           t.Intercom("update", {
  //             hide_default_launcher: true,
  //           });
  //         }
  //       });
  //   };
  //   const event = t.attachEvent ? t.attachEvent("onload", i) : t.addEventListener("load", i, !1);
  //   document.readyState === "complete" ? i() : event;
  // }
}

export default loadIntercom;
